module.exports = __webpack_public_path__ + "img/484.11b1d7dc.png";